export const REACTION = 'reaction'
export const EMOJI = 'emoji'
export const GIPHY = 'giphy'
